module.exports = __webpack_public_path__ + "static/media/Revit Extension for Autodesk Extension.de31f788.png";